import {ValidationStepConfig} from 'src/types/form';
import {RegistrationSteps} from 'src/types/enums';
import validateCitizenshipStep from 'shared/student/registration/validations/validate-citizenship-step';
import Citizenship from 'src/components/form/onboarding/Citizenship/Citizenship';
import {HighSchoolInformationForm} from 'src/types/onboarding';

export default Citizenship;

export const CitizenshipConfig: ValidationStepConfig<HighSchoolInformationForm, void> = {
  key: RegistrationSteps.CITIZENSHIP,
  Component: Citizenship,
  validate: validateCitizenshipStep,
};
